<template>
  <iColumn gap="large">
    <iColumn gap="none">
      <iTextInput
        :model-value="formData.inviteeName"
        label="Name"
        placeholder="Enter invitee's name"
        width="fill"
        focus
        required
        @update:model-value="updateInviteeName($event)"
      />
      <iText v-if="validationErrors.inviteeName" variant="error">
        {{ validationErrors.inviteeName }}
      </iText>
    </iColumn>

    <iColumn gap="none">
      <iTextInput
        :model-value="formData.inviteeEmail"
        label="Email"
        placeholder="Enter invitee's email"
        width="fill"
        required
        @update:model-value="updateInviteeEmail($event)"
      />
      <iText v-if="validationErrors.inviteeEmail" variant="error">
        {{ validationErrors.inviteeEmail }}
      </iText>
    </iColumn>

    <iColumn gap="none">
      <iSelect
        :model-value="formData.selectedRole"
        label="Role"
        :items="ROLE_OPTIONS"
        value-field="value"
        text-field="name"
        empty-string="Choose a role"
        width="fill"
        required
        @update:model-value="updateSelectedRole($event)"
      />
      <iText v-if="validationErrors.role" variant="error">
        {{ validationErrors.role }}
      </iText>
    </iColumn>

    <iColumn gap="none">
      <iTextArea
        :model-value="formData.inviteMessage"
        label="Invite Message"
        placeholder="Enter invitation message..."
        :rows="5"
        width="fill"
        @update:model-value="updateInviteMessage($event)"
      />
    </iColumn>
    <iSpace />
    <iRow
      vertical-align="middle"
      align="right"
      width="fill"
    >
      <iButton
        v-if="showProposeContractButton"
        :is-loading="isLoading"
        loading-spinner-position="inside"
        @click="callOnSubmit"
      >
        Send Invite
      </iButton>
    </iRow>
  </iColumn>
</template>

<script>
import { ROLE_OPTIONS } from "@/constants/collaborator-constants";
import { createFormMethods } from "@/helpers/form-helpers";

export default {
  name: "InviteCollaboratorForm",
  props: {
    formData: {
      type: Object,
      required: true,
    },
    validationErrors: {
      type: Object,
      required: true,
    },
    showProposeContractButton: {
      type: Boolean,
      default: false,
      required: false,
    },
    onSubmit: {
      type: Function,
      default: null,
      required: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  emits: ["update:formData", "update:validationErrors"],
  data() {
    return {
      ROLE_OPTIONS,
    };
  },
  methods: {
    ...createFormMethods([
      "inviteeName",
      "inviteeEmail",
      "selectedRole",
      "inviteMessage",
    ]),
    callOnSubmit() {
      if (this.validateFormData()) {
        this.onSubmit();
      }
    },
    validateFormData() {
      const errors = {};

      if (!this.formData.inviteeName || this.formData.inviteeName.trim() === "") {
        errors.inviteeName = "Name is required";
      }

      if (!this.formData.inviteeEmail || this.formData.inviteeEmail.trim() === "") {
        errors.inviteeEmail = "Email is required";
      } else if (!this.isValidEmail(this.formData.inviteeEmail)) {
        errors.inviteeEmail = "Please enter a valid email address";
      }

      if (!this.formData.selectedRole || !this.formData.selectedRole.value) {
        errors.role = "Role is required";
      }

      this.$emit("update:validationErrors", errors);

      return Object.keys(errors).length === 0;
    },
    isValidEmail(email) {
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return regex.test(email);
    },
  },
};
</script>
